import { DanjiMemulListParamsType } from '@/app/(memul)/(list)/danji/[danjiCd]/type';
import { RealtorMemulListParamsType } from '@/app/(realtor)/realtor/[realtorCd]/type';
import { RealtorListParamsType } from '@/app/(realtor)/realtor/type';
import { FeedMaeburiListParamsType } from '@/app/feed/maeburi/types';
import { FeedNewsListParamsType } from '@/app/feed/news/types';
import { FeedTipListParamsType } from '@/app/feed/tip/types';
import { EventListParamsType } from '@/app/help/event/type';
import { MemulListParamsType } from '@/service/commonType';

const queryKeyFactory = {
  memul: {
    list: (params: MemulListParamsType) => ['memulList', params],
    listCount: (params: MemulListParamsType) => ['memulListCount', params],
    sameList: (sameSeq: number) => ['memulFavorite', 'memulSameList', sameSeq],
  },
  danji: {
    list: (params: MemulListParamsType) => ['danjiList', params],
    listCount: (params: MemulListParamsType) => ['danjiListCount', params],
    detail: (params: string) => ['danjiDetail', params],
    detailPrice: (params: string) => ['danjiDetailPrice', params],
    dong: (params: string) => ['danjiDetailDong', params],
    memulList: (params: DanjiMemulListParamsType) => ['memulList', { type: 'danji', ...params }],
  },
  search: {
    complex: (params: { keyword: string }) => ['searchComplex', params],
    regions: (params: { keyword: string }) => ['searchRegion', params],
    offerings: (params: { keyword: string }) => ['searchOfferings', params],
  },
  help: {
    eventList: (params: EventListParamsType) => ['helpEventList', JSON.stringify(params)],
    eventDetail: (eventCd: string) => ['helpEventDetail', eventCd],
  },
  realtor: {
    list: (params: RealtorListParamsType) => ['realtorList', JSON.stringify(params)],
    info: (realtorCd: string) => ['realtorInfo', realtorCd],
    memulList: (params: RealtorMemulListParamsType) => [
      'memulList',
      JSON.stringify({ type: 'relator', params }),
    ],
  },
  feed: {
    category: () => ['feed', 'news', 'category'],
    newsList: (params: FeedNewsListParamsType) => ['feedNewsList', JSON.stringify(params)],
    tipList: (params: FeedTipListParamsType) => ['feedTipList', JSON.stringify(params)],
    maeburiList: (params: FeedMaeburiListParamsType) => ['feedMaeburiList', JSON.stringify(params)],
    newsDetail: (newsSn: string) => ['feedNewsDetail', newsSn],
    tipDetail: (tipCd: string) => ['feedTipDetail', tipCd],
    tipRecommend: (tipCd: string) => ['feedTipRecommend', tipCd],
  },
};
export default queryKeyFactory;
